import { forwardRef } from "react";
import type { HTMLAttributes } from "react";
import { cn } from "../../lib/utils";

const ItemSeparator = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>(({ className, ...props }, ref) => {
  return <div ref={ref} className={cn("h-px bg-border", className)} {...props} />;
});
ItemSeparator.displayName = "ItemSeparator";

const ItemActions = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>(({ className, ...props }, ref) => {
  return <div ref={ref} className={cn("flex items-center gap-2", className)} {...props} />;
});
ItemActions.displayName = "ItemActions";

const ItemHeader = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>(({ className, ...props }, ref) => {
  return <div ref={ref} className={cn("flex items-center justify-between gap-2", className)} {...props} />;
});
ItemHeader.displayName = "ItemHeader";

const ItemFooter = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>(({ className, ...props }, ref) => {
  return <div ref={ref} className={cn("flex items-center gap-2", className)} {...props} />;
});
ItemFooter.displayName = "ItemFooter";

export { ItemSeparator, ItemActions, ItemHeader, ItemFooter };
